import script from "./AppSpinner.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppSpinner.vue?vue&type=script&lang=ts&setup=true"

import "./AppSpinner.vue?vue&type=style&index=0&id=6d6068c1&lang=scss"

const __exports__ = script;

export default __exports__